export default {
	SET_PENDING_ORDER: "SET_PENDING_ORDER",
	TOGGLE_SHOW_PENDING_RECEIPT: "TOGGLE_SHOW_PENDING_RECEIPT",
	TOGGLE_SHOW_TERMS_AND_CONDITIONS: "TOGGLE_SHOW_TERMS_AND_CONDITIONS",
	TOGGLE_SHOW_TERMS_AND_CONDITIONS_POLITIK: "TOGGLE_SHOW_TERMS_AND_CONDITIONS_POLITIK",
	TOGGLE_SHOW_INFO_PAGE: "TOGGLE_SHOW_INFO_PAGE",
	SET_FOREIGN_ORDER_NUMBER: "SET_FOREIGN_ORDER_NUMBER",
	SET_SELECTED_MENU_POSITION: "SET_SELECTED_MENU_POSITION",
	SET_LAST_ORDER_CREATED_TIME: "SET_LAST_ORDER_CREATED_TIME",
	RESET_LAST_ORDER_CREATED_TIME: "RESET_LAST_ORDER_CREATED_TIME",
	RESET_STORE_FOR_NEW_CUSTOMER: "RESET_STORE_FOR_NEW_CUSTOMER",
	TERMINAL_PAYMENT_FAILED: "TERMINAL_PAYMENT_FAILED",
	HIGHLIGHT_UPSELL_PRODUCTS: "HIGHLIGHT_UPSELL_PRODUCTS",
	HIGHLIGHT_ADDON_PRODUCTS: "HIGHLIGHT_ADDON_PRODUCTS",
	INDICATE_ADD_TO_BASKET: "INDICATE_ADD_TO_BASKET",
	QUANTITY_BEFORE_CHANGE: "QUANTITY_BEFORE_CHANGE",
	SET_ORDER_STEP: "SET_ORDER_STEP",
	SET_LOGIN_STEP: "SET_LOGIN_STEP",
	SHOW_NOTIFICATIONS_PRE_SCREEN: "SHOW_NOTIFICATIONS_PRE_SCREEN",
	SET_FEEDBACK_INITIATOR: "SET_FEEDBACK_INITIATOR",
	SET_TERMS_CONDITIONS_INITIATOR: "SET_TERMS_CONDITIONS_INITIATOR",
	SET_COUNTRY_INFO_DATA: "SET_COUNTRY_INFO_DATA",
	CHANGE_BASKET_STATE_CONTROL: "CHANGE_BASKET_STATE_CONTROL",
	KIOSK_UPDATE_REQUESTED: "KIOSK_UPDATE_REQUESTED",
	SET_LANDING_PAGE_MOBILE_MARKETING_CARD_LAST_UPDATED_TIME: "SET_LANDING_PAGE_MOBILE_MARKETING_CARD_LAST_UPDATED_TIME",
	SET_PENDING_ORDER_SHOP_ID: "SET_PENDING_ORDER_SHOP_ID"
};
